module.exports = __webpack_public_path__ + "static/media/47.8180d443.png";